import { differenceInCalendarDays, format } from 'date-fns';

/**
 * Ember `moment.shortCalendar` parity — the format the deliveries `ShortDate`
 * uses in the "Date Created" column. A calendar-relative label with a
 * lowercase meridiem for the surrounding week ("today at 3:14 pm", "yesterday
 * at …", the weekday name for other days within a week), and a plain
 * "MMM D, YYYY" with no time for anything older or further out. `now` is
 * injectable for tests.
 */
export function formatShortCalendar(epochSeconds: number, now: Date = new Date()): string {
  const date = new Date(epochSeconds * 1000);
  const dayDiff = differenceInCalendarDays(date, now);

  // Beyond the surrounding week (moment's `sameElse`): date only, no time.
  if (dayDiff < -6 || dayDiff > 6) {
    return format(date, 'MMM d, yyyy');
  }

  const time = format(date, 'h:mm a').toLowerCase();
  if (dayDiff === 0) {
    return `today at ${time}`;
  }
  if (dayDiff === -1) {
    return `yesterday at ${time}`;
  }
  if (dayDiff === 1) {
    return `tomorrow at ${time}`;
  }
  return `${format(date, 'EEEE')} at ${time}`;
}
